<template>
  <svg class="pc-icon">
    <use :xlink:href="`${spritePath}#${props.name}`"></use>
  </svg>
</template>

<script setup lang="ts">
import { ref, onMounted } from "vue";

const props = defineProps({
  name: String,
});

const spritePath = ref<string>("");

onMounted(async () => {
  try {
    spritePath.value = `${window.location.origin}/assets/svg/sprite.svg`;
    // console.log("SVG sprite path:", spritePath.value);
  } catch (error) {
    // console.error("Error loading SVG sprite:", error);
  }
});
</script>
